<div>
  <div style="display:flex; justify-content: flex-end;margin:6px">
    <button pButton label="Volver a la Bandeja" icon="pi pi-backward" (click)="navegar('/MantClientes')"></button>
  </div>
  <div class="main-container">
    <p-card class="card-container" header="Asignación de Ejecutivos" styleClass="mb-4">
      <form [formGroup]="ejecutivosSearchForm">
        <div class="search-controls">
          <div class="p-field">
            <label for="ejecutivo-nombre">Nombre del Ejecutivo</label>
            <input class="custom-search-input" id="ejecutivo-nombre" type="text" pInputText formControlName="nombre" placeholder="Buscar por nombre..." />
          </div>

          <!-- <div class="p-field">
            <label for="ejecutivo-estado">Estado</label>
            <select id="ejecutivo-estado" formControlName="estado" class="custom-search-input">
              @for (option of estadoOptions; track option.value) {
                <option [ngValue]="option.value">
                  {{ option.label }}
                </option>
              }
            </select>
          </div> -->

          <div class="p-field-button">
            <button pButton label="Buscar" icon="pi pi-search" (click)="buscarListadoEntidades(3)"></button>
          </div>
        </div>
      </form>

      <p-table [value]="ejecutivosList()">
        <ng-template pTemplate="header">
          <tr>
            <th>Nombre Completo</th>
            <th>Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ejecutivo>
          <tr>
            <td>{{ ejecutivo.razon_social }}</td>
            <td>
              <button
                style="height: 25px;width: 25px;"
                pButton
                icon="pi pi-plus"
                class="p-button-rounded p-button-success"
                (click)="abrirDialogAsignarEntidad(3, ejecutivo)"
              ></button>
            </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">No se encontraron ejecutivos.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>

    <p-card class="card-container" header="Asignación de Customers" styleClass="mb-4">
      <form [formGroup]="customersSearchForm">
        <div class="search-controls">
          <div class="p-field">
            <label for="customer-nombre">Nombre del Customer</label>
            <input class="custom-search-input" id="customer-nombre" type="text" pInputText formControlName="nombre" placeholder="Buscar por nombre..." />
          </div>

          <!-- <div class="p-field">
            <label for="customer-estado">Estado</label>
            <select id="customer-estado" formControlName="estado" class="custom-search-input">
              @for (option of estadoOptions; track option.value) {
                <option [ngValue]="option.value">
                  {{ option.label }}
                </option>
              }
            </select>
          </div> -->

          <div class="p-field-button">
            <button pButton label="Buscar" icon="pi pi-search" (click)="buscarListadoEntidades(4)"></button>
          </div>
        </div>
      </form>

      <p-table [value]="customersList()">
        <ng-template pTemplate="header">
          <tr>
            <th>Nombre Completo</th>
            <th>Acciones</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
          <tr>
            <td>{{ customer.razon_social }}</td>
            <td>
              <button
                pButton
                style="height: 25px;width: 25px;"
                icon="pi pi-plus"
                class="p-button-rounded p-button-success"
                (click)="abrirDialogAsignarCustomer(customer)"
              ></button>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2">No se encontraron customers.</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
</div>



<p-dialog
  [(visible)]="showDialog"
  [modal]="true"
  [style]="{ width: '70vw' }"
  class="asignacion-clientes-dialog"
  [header]="tittleHeader"
  [maximizable]="true"
>
  <div class="picklist-dialog-content">
    @if (loadingClientesParaAsignar()) {
      <div class="spinner-overlay">
        <p-progressSpinner></p-progressSpinner>
      </div>
    } @else {
      <div class="dual-list-container">
        <div class="list">
          <h3>
            Asignados - Cantidad Total: {{ asignados().length }}
            <button (click)="moverTodosANoAsignados()"
                    [disabled]="!hasRecentAssigned()">
              ➔ Devolver agregados
            </button>
          </h3>
          <div class="filter-controls-container">
            <div class="checkbox-group">
              <label>
                <input type="checkbox" [checked]="filtroAsignadosPorGrupo()" (change)="setCheckboxSignal(filtroAsignadosPorGrupo, $event)" [disabled]="filtroAsignadosPorGrupo() && !filtroAsignadosPorCliente()" /> Grupo
              </label>
              <label>
                <input type="checkbox" [checked]="filtroAsignadosPorCliente()" (change)="setCheckboxSignal(filtroAsignadosPorCliente, $event)" [disabled]="filtroAsignadosPorCliente() && !filtroAsignadosPorGrupo()" /> Cliente
              </label>

            </div>
            <input #txtAsignados type="text"
                  class="custom-search-input"
                  placeholder="Buscar..."
                  (input)="filtroAsignadosTerm.set(txtAsignados.value)" />
          </div>
          <div class="list-container" style="max-height: 470px;">
            @for (item of asignados(); track getTrackByValue(item)) {
              @if (esGrupo(item)) {
                <div class="list-item grupo-item" [ngClass]="{'bg-green-400': item.clientes[0]?.tipoRegistro !== 'Asignado'}">
                  <div class="grupo-header">
                    <button class="toggle-btn" (click)="toggleGrupo(item)">
                      {{ item.expandido ? '-' : '+' }}
                    </button>
                    <span class="item-name">{{ item.nombre_grupo }}</span>
                    <button style="height:1rem;" pButton pRipple icon="pi pi-info-circle" class="p-button-rounded p-button-text p-button-sm info-btn" (click)="showInfoPopover($event, item)"></button>
                    <!-- @if(item.clientes[0].tipoRegistro !== 'Asignado') {
                    } -->
                    <button class="move-btn" (click)="moverANoAsignados(item)">➔</button>
                  </div>
                  @if (item.expandido) {
                    <div class="grupo-clientes">
                      @for (c of item.clientes; track c.entC_Codigo) {
                        <div class="cliente-row">
                          {{ c.razon_social }} ({{ c.entC_DocIden }})
                        </div>
                      }
                    </div>
                  }
                  </div>
              } @else {
                <div class="list-item cliente-item" [ngClass]="{'bg-green-400': item.tipoRegistro !== 'Asignado'}">
                  <div class="cliente-row">
                    <span class="item-name">{{ item.razon_social }} ({{ item.entC_DocIden }})</span>
                    <button style="height:1rem;" pButton pRipple icon="pi pi-info-circle" class="p-button-rounded p-button-text p-button-sm info-btn" (click)="showInfoPopover($event, item)"></button>
                    <!-- @if(item.tipoRegistro !== 'Asignado') {
                    } -->
                    <button class="move-btn" (click)="moverANoAsignados(item)">➔</button>
                  </div>
                </div>
              }
            } @empty {
              <div class="no-items">No hay clientes asignados.</div>
            }
          </div>
        </div>
        <div class="list">
          <h3>No asignados - CANTIDAD: {{noAsignados().length}}
            <button (click)="moverTodosAAsignados()" [disabled]="noAsignados().length === 0">
              Mover todos ⬅
            </button>
          </h3>
          <div class="filter-controls-container">
            <div class="filter-selects">
              <label>Tipo Régimen:
                <select style="font-size: x-small;" [value]="filtroTipoRegimen()" (change)="onFiltroTipoRegimenChange($event)">
                  @for (opcion of opcionesTipoRegimen; track opcion.value) {
                    <option [value]="opcion.value">{{ opcion.label }}</option>
                  }
                </select>
              </label>
              <label>Tipo Tráfico:
                <select style="font-size: x-small;" [value]="filtroTipoTrafico()" (change)="onFiltroTipoTraficoChange($event)">
                  @for (opcion of opcionesTipoTrafico; track opcion.value) {
                    <option [value]="opcion.value">{{ opcion.label }}</option>
                  }
                </select>
              </label>
            </div>
            <div class="checkbox-group">
              <label>
                <input type="checkbox" [checked]="filtroNoAsignadosPorGrupo()" (change)="setCheckboxSignal(filtroNoAsignadosPorGrupo, $event)" [disabled]="filtroNoAsignadosPorGrupo() && !filtroNoAsignadosPorCliente()" /> Grupo
              </label>
              <label>
                <input type="checkbox" [checked]="filtroNoAsignadosPorCliente()" (change)="setCheckboxSignal(filtroNoAsignadosPorCliente, $event)" [disabled]="filtroNoAsignadosPorCliente() && !filtroNoAsignadosPorGrupo()" /> Cliente
              </label>
            </div>
            <div class="filter-selects">
              <label>Buscar por Ejecutivo:
                <select style="font-size: x-small;"
                      [value]="filtroEjecutivoNoAsignados() ?? ''"
                      (change)="filtroEjecutivoNoAsignados.set($any($event.target).value ? +$any($event.target).value : null)">
                <option style="font-size: x-small;" value="">No asignados</option>
                @for (ej of listaEjecutivosSelect; track ej.entC_Codigo) {
                  <option style="font-size: x-small;" [value]="ej.entC_Codigo">{{ ej.razon_social }}</option>
                }
              </select>
              </label>
            </div>

            <input #txtNoAsignados type="text"
                  class="custom-search-input"
                  placeholder="Buscar..."
                  (input)="filtroNoAsignadosTerm.set(txtNoAsignados.value)" />
          </div>
          <div class="list-container" style="max-height: 450px;">
            @for (item of noAsignados(); track getTrackByValue(item)) {
              @if (esGrupo(item)) {
                <div class="list-item grupo-item" [ngClass]="{'bg-red-400': item.clientes[0]?.tipoRegistro !== 'No asignado'}">
                  <div class="grupo-header">
                    <button class="toggle-btn" (click)="toggleGrupo(item)">
                      {{ item.expandido ? '-' : '+' }}
                    </button>
                    <span>{{ item.nombre_grupo }}</span>
                    <button class="move-btn" (click)="moverAAsignados(item)">⬅</button>
                  </div>
                  @if (item.expandido) {
                    <div class="grupo-clientes">
                      @for (c of item.clientes; track c.entC_Codigo) {
                        <div class="cliente-row">
                          {{ c.razon_social }} ({{ c.entC_DocIden }})
                        </div>
                      }
                    </div>
                  }
                </div>
              } @else {
                <div class="list-item cliente-item" [ngClass]="{'bg-red-400': item.tipoRegistro !== 'No asignado'}">
                  <div class="cliente-row">
                    {{ item.razon_social }} ({{ item.entC_DocIden }})
                    <button class="move-btn" (click)="moverAAsignados(item)">⬅</button>
                  </div>
                </div>
              }
            } @empty {
              <div class="no-items">No hay clientes no asignados.</div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <p-popover #op>
    <ng-container *ngIf="itemSeleccionadoParaPopover() as item">
      <div class="popover-content">
        <span class="font-medium block mb-2">{{ esGrupo(item) ? item.nombre_grupo : item.razon_social }}</span>
        <div class="text-sm">
          <p><strong>Tipo de Régimen:</strong> {{ getLabelTipoRegimen(esGrupo(item) ? item.clientes[0].conS_CodRGM : item.conS_CodRGM) }}</p>
          <p><strong>Tipo de Tráfico:</strong> {{ getLabelTipoTrafico(esGrupo(item) ? item.clientes[0].tipO_CodTRF : item.tipO_CodTRF) }}</p>
        </div>
      </div>
    </ng-container>
  </p-popover>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton label="Cancelar" icon="pi pi-times" (click)="cancelar()"></button>
      <button pButton label="Guardar" icon="pi pi-check" [disabled]="" (click)="guardarAsignacion()"></button>
    </div>
  </ng-template>
</p-dialog>


<p-dialog
  [(visible)]="showDialogCustomer"
  [modal]="true"
  [style]="{ width: '70vw' }"
  class="asignacion-clientes-dialog"
  [header]="tittleHeaderCustomer"
  [maximizable]="true"
>
  <div class="picklist-dialog-content">
    @if (loadingClientesParaAsignar()) {
      <div class="spinner-overlay">
        <p-progressSpinner></p-progressSpinner>
      </div>
    } @else {
      <div class="dual-list-container">
        <div class="list">
          <h3>Ejecutivos Asignados</h3>
          <div class="filter-controls-container">
            <input #txtAsignadosEjecutivos type="text"
                  class="custom-search-input"
                  placeholder="Buscar..."
                  (input)="filtroAsignadosEjecutivosTerm.set(txtAsignadosEjecutivos.value)" />
          </div>
          <div class="list-container" style="max-height: 470px;">
            @for (item of asignadosEjecutivos(); track getTrackByValueCustomer(item)) {
              <div class="list-item cliente-item"
                  [ngClass]="{
                    'bg-green-400': item.cambioEstado === 'agregado',
                    '': !item.cambioEstado
                  }">
                <div class="cliente-row">
                  <span class="item-name">{{ item.nombre_ejecutivo }}</span>
                  <button class="move-btn" (click)="moverANoAsignadosEjecutivos(item)">➔</button>
                </div>
              </div>
            } @empty {
              <div class="no-items">No hay ejecutivos asignados.</div>
            }
          </div>
        </div>
        <div class="list">
          <h3>Lista de Ejecutivos No Asignados</h3>
          <div class="filter-controls-container">
            <div class="filter-selects">
              <label>Buscar por Customer:
                <select style="font-size: x-small;"
                      [value]="filtroCustomerNoAsignados() ?? ''"
                      (change)="filtroCustomerNoAsignados.set($any($event.target).value ? +$any($event.target).value : null)">
                <option style="font-size: x-small;" value="">No asignados</option>
                @for (ej of listaCustomerSelect; track ej.entC_Codigo) {
                  <option style="font-size: x-small;" [value]="ej.entC_Codigo">{{ ej.razon_social }}</option>
                }
              </select>
              </label>
            </div>

            <input #txtNoAsignadosEjecutivos type="text"
                  class="custom-search-input"
                  placeholder="Buscar..."
                  (input)="filtroNoAsignadosEjecutivosTerm.set(txtNoAsignadosEjecutivos.value)" />
          </div>
          <div class="list-container" style="max-height: 450px;">
            @for (item of noAsignadosEjecutivos(); track getTrackByValueCustomer(item)) {
              <div class="list-item cliente-item"
                  [ngClass]="{
                    'bg-red-400': item.cambioEstado === 'removido',
                    '': !item.cambioEstado
                  }">
                <div class="cliente-row">
                  {{ item.nombre_ejecutivo }}
                  <button class="move-btn" (click)="moverAAsignadosEjecutivos(item)">⬅</button>
                </div>
              </div>
            } @empty {
              <div class="no-items">No hay ejecutivos no asignados.</div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button pButton label="Cancelar" icon="pi pi-times" (click)="cerrar()"></button>
      <button pButton label="Guardar" icon="pi pi-check" [disabled]="" (click)="guardarAsignacionCustomer()"></button>
    </div>
  </ng-template>
</p-dialog>
